// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607281553/js/" + chunkId + "." + {"44":"55b7486a","225":"91d80ff5","481":"9ca3cd15","486":"0334c46c","770":"f5f7cce5"}[chunkId] + ".0.23131971475432944.chunk.js";
};